import {classNames, React, useEffect} from '@api'
import * as css from './ExceptionDetails.css'
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/1337.css'

export const ExceptionDetails : React.FC<{ className?: string, error: Error & { extraJson?: Array<{label: string, json: any}>}}> = ({className, error}) => {
  useEffect(() => {
    console.error(error)
  }, [])
  return <div className={classNames(css.root, className)}>
    <code className={css.details}>{error.toString()}</code>

    {error.extraJson?.map(({label, json}) => (
      <div className={css.extraJson}>
        <span className={css.label}>{label}</span>
        <JSONPretty className={css.json} data={json}/>
      </div>))}
  </div>
}


// WEBPACK FOOTER //
// ./src/modules/errors/components/ExceptionDetails.tsx